import { createApiQuery } from '@/hooks/use-api-query';
import { get } from '@/libs/http';
import { CasinoReq, CasinoRes } from '@/types/api/hall/casino';

export const getCasinoList = (params?: CasinoReq) => get<CasinoRes>('/hall/v1/casino', { params });

export const useCasinoList = createApiQuery(getCasinoList, (params?: CasinoReq) => ['casinoList', params]);
